import { Routes } from '@angular/router';

import { environment } from '@environments';

import { AboutUs } from '@pages/about-us/about-us';
import { ArticleDetail } from '@pages/article-detail/article-detail';
import { CategoryList } from '@pages/category-list/category-list';
import { Contact } from '@pages/contact/contact';
import { Home } from '@pages/home/home';
import { MagazineDetail } from '@pages/magazine-detail/magazine-detail';
import { MagazineList } from '@pages/magazine-list/magazine-list';
import { Newsletter } from '@pages/newsletter/newsletter';
import { NotFound } from '@pages/not-found/not-found';
import { Opus } from '@pages/opus/opus';
import { Privacy } from '@pages/privacy/privacy';
import { Search } from '@pages/search/search';
import { Terms } from '@pages/terms/terms';
import { VideoList } from '@pages/video-list/video-list';

export const routes: Routes = [
  {
    path: '',
    component: Home,
    title: `${environment.title}`,
    pathMatch: 'full',
  },
  {
    path: 'acerca-de-nosotros',
    component: AboutUs,
    title: `Acerca de nosotros - ${environment.title}`,
  },
  {
    path: 'articulo/:slug',
    component: ArticleDetail,
    title: `Artículo - ${environment.title}`,
  },
  {
    path: 'archivo',
    component: MagazineList,
    title: `Archivo - ${environment.title}`,
  },
  {
    path: 'aviso-de-privacidad',
    component: Privacy,
    title: `Aviso de Privacidad - ${environment.title}`,
  },

  {
    path: 'buscar',
    component: Search,
    title: `Buscar - ${environment.title}`,
  },
  {
    path: 'contacto',
    component: Contact,
    title: `Contacto - ${environment.title}`,
  },
  {
    path: 'liber/:slug',
    component: MagazineDetail,
    title: `Archivo - ${environment.title}`,
  },
  {
    path: 'newsletter',
    component: Newsletter,
    title: `Newsletter - ${environment.title}`,
  },
  // {
  //   path: 'opus',
  //   component: Opus,
  //   title: `Opus - ${environment.title}`,
  // },
  {
    path: 'seccion/:slug',
    component: CategoryList,
    title: `Sección - ${environment.title}`,
  },
  {
    path: 'terminos-y-condiciones',
    component: Terms,
    title: `Términos y Condiciones - ${environment.title}`,
  },
  {
    path: 'videos',
    component: VideoList,
    title: `Videos - ${environment.title}`,
  },
  // {
  //   path: 'videos/:slug',
  //   component: VideoDetail,
  //   title: `Videos - ${environment.title}`,
  // },
  {
    path: '**',
    component: NotFound,
    title: `Página no encontrada - ${environment.title}`,
  },
];
